import { registerPrimitive } from '../primitives.js';

registerPrimitive('a-gltf-model', {
  mappings: {
    src: 'gltf-model'
  }
});
